import React from 'react';

export const COLOR_PICKER_FALLBACK = '#ec4899';
const HEX6 = /^#[0-9A-Fa-f]{6}$/;

export function toColorPickerValue(color: string, fallback = COLOR_PICKER_FALLBACK): string {
  const trimmed = color.trim();
  if (!HEX6.test(trimmed)) {
    return fallback;
  }
  return trimmed.toLowerCase();
}

export interface ColorPickerFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  hasError?: boolean;
}

export default function ColorPickerField({
  value,
  onChange,
  placeholder,
  disabled,
  hasError,
}: ColorPickerFieldProps) {
  const pickerValue = toColorPickerValue(value);
  const inputClass = [
    'profase-form-input',
    hasError ? 'profase-form-input--error' : '',
    disabled ? 'profase-form-input--disabled' : '',
  ].filter(Boolean).join(' ');

  return (
    <div style={s.row}>
      <input
        type="color"
        aria-label="Selector de color"
        value={pickerValue}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        style={s.swatch}
      />
      <input
        className={inputClass}
        type="text"
        aria-label="Color hexadecimal"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={e => onChange(e.target.value)}
        style={s.hex}
      />
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  swatch: {
    width: 44,
    height: 38,
    padding: 3,
    border: '1px solid var(--crm-border)',
    borderRadius: 8,
    background: 'var(--crm-input-bg)',
    cursor: 'pointer',
    flexShrink: 0,
    boxSizing: 'border-box',
  },
  hex: {
    flex: 1,
    minWidth: 0,
  },
};
